import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

const decodeTokenEmail = () => {
  try {
    const tok = localStorage.getItem("client_token") || sessionStorage.getItem("client_token");
    if (!tok) return "";
    const payload = JSON.parse(atob(tok.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
    return (payload.email || "").toLowerCase();
  } catch {
    return "";
  }
};

export const knownClientEmail = () => {
  try {
    return (
      decodeTokenEmail() ||
      localStorage.getItem("kl_client_email") ||
      localStorage.getItem("kl_booking_email") ||
      localStorage.getItem("kl_last_email") ||
      ""
    ).trim().toLowerCase();
  } catch {
    return "";
  }
};

// Tell the backend which language this client browses in (fire-and-forget, once per email+language).
export const reportLanguagePreference = (email, language) => {
  const em = (email || knownClientEmail() || "").trim().toLowerCase();
  const lang = language === "fr" ? "fr" : "en";
  if (!em || !em.includes("@") || !API) return;
  const marker = `kl_lang_reported:${em}`;
  try {
    if (localStorage.getItem(marker) === lang) return;
    localStorage.setItem(marker, lang);
  } catch { /* noop */ }
  axios.post(`${API}/api/client/language-preference`, { email: em, language: lang }, { timeout: 8000 }).catch(() => {});
};
